import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { cx } from '@emotion/css'
import Link from '../../molecules/link'
import { ImageBackgroundArtDirection } from '../../particles/art-direction'
import RichContent from '../../particles/rich-content'
import {
	ChildrenCategories,
	Count,
	Description,
	ImageWrapper,
	Name,
	Overlay,
	SiblingsCategories,
	TitleWrapper,
} from './heading.styled'

const Heading = ({
	className,
	childrenCategories,
	description,
	image,
	imageMobile,
	productsCount,
	title,
	titleProps,
	variant,
	entityId,
	siblingsCategories,
}) => {
	const {
		catalog: {
			categories: {
				heading: { height },
				showProductsCount: showProductsCount,
				siblingsCategories: showSiblingsCategories,
			},
		},
	} = useConfig()

	switch (variant) {
		case 'hidden':
			return null
		case 'banner':
			return (
				<ImageWrapper className={className} minHeight={height}>
					{imageMobile || image ? (
						<ImageBackgroundArtDirection
							height={height}
							sources={{
								xs: imageMobile ? mediaUrl(imageMobile) : mediaUrl(image),
								...(image ? { sm: mediaUrl(image) } : null),
							}}
							sx={{
								height: { xs: height, sm: height },
								width: '100%', //TODO: implement mobile height config
							}}
						/>
					) : null}

					<Overlay>
						{showProductsCount && productsCount > 0 && (
							<Count variant="subheadline2">{'(' + productsCount + ')'}</Count>
						)}

						{showSiblingsCategories && siblingsCategories?.length > 0 && (
							<SiblingsCategories justifyContent="center">
								{siblingsCategories.map(({ name, path, id }) => (
									<Link
										key={id}
										href={id !== entityId ? path : null}
										underline="none"
										className={cx(id === entityId && 'active')}
									>
										{name}
									</Link>
								))}
							</SiblingsCategories>
						)}

						{childrenCategories?.length > 0 && (
							<ChildrenCategories justifyContent="center">
								{childrenCategories.map(({ name, path, id }) => (
									<Link key={id} href={path} underline="none">
										{name}
									</Link>
								))}
							</ChildrenCategories>
						)}

						{title && (
							<Name component="h1" variant="h1" {...titleProps}>
								{title}
							</Name>
						)}

						{description?.length > 0 ? (
							<Description>
								<RichContent content={description} />
							</Description>
						) : null}
					</Overlay>
				</ImageWrapper>
			)
		default:
			return (
				<TitleWrapper className={className}>
					{title && (
						<Name component="h1" variant="h1" {...titleProps}>
							{title}
						</Name>
					)}

					{showProductsCount && productsCount > 0 && <Count variant="subheadline2">{'(' + productsCount + ')'}</Count>}
				</TitleWrapper>
			)
	}
}

export default Heading
